module.exports = __webpack_public_path__ + "img/andriod3.07cc04c9.png";